import React, { useState, useEffect } from "react";
import Home from "./components/HomePage";
import Signup from "./components/Signup";
import Login from "./components/Login";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom"; // Update import statement to include Link
import Header from "./components/Header";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { auth, database } from "./firebase";
import { get, ref, onValue } from "firebase/database";
import PopularShortcutsGrid from "./components/PopularShortcutsGrid";
import popularShortcutsData from "./public/popularShortcutsData";

import "./styles/App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  // Function to handle user login
  const handleLogin = (email, password) => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        setUser(user);
        setIsLoggedIn(true);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.error(errorCode, errorMessage);
      });
  };

  // Function to handle user logout
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        setUser(null);
        setIsLoggedIn(false);
      })
      .catch((error) => {
        // An error happened.
      });
  };

  // Check if the user is already logged in when the app starts
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        setUser(user);
        setIsLoggedIn(true);
      } else {
        // User is signed out
        setUser(null);
        setIsLoggedIn(false);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, []);

  return (
    <Router basename="/KeyboardShortcutTracker">
      <div>
        <Header isLoggedIn={isLoggedIn} onLogout={handleLogout} />
        <section>
          <Routes>
            {/* Route for the logged-in user */}
            {isLoggedIn && (
              <Route
                path="/"
                element={
                  <Home isLoggedIn={isLoggedIn} user={user} />
                }
              />
            )}

            {/* Route for the logged-out user */}
            {!isLoggedIn && (
              <Route
                path="/"
                element={
                  <>
                    <div className="py-4 px-6 bg-gray-200">
                      <h2 className="text-xl font-semibold mb-4">Popular Shortcuts</h2>
                      <PopularShortcutsGrid popularShortcuts={popularShortcutsData}/>
                    </div>
                    <div>
                      <p>Other content for logged-out users if needed</p>
                    </div>
                  </>
                }
              />
            )}

            {/* Add other routes (Signup, Login, etc.) */}
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login handleUserLogin={handleLogin} />} />
          </Routes>
        </section>
      </div>
    </Router>
  );
}

export default App;
